import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgLockClose = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M8 0a4 4 0 0 1 4 4v2l.204.01A2 2 0 0 1 14 8v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2h4V4a2 2 0 0 0-2-2"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLockClose);
export default ForwardRef;
